import { render, staticRenderFns } from "./CreateLessonPage.vue?vue&type=template&id=4683d41c&"
import script from "./CreateLessonPage.vue?vue&type=script&lang=ts&"
export * from "./CreateLessonPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports